import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { Form, useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { ApiCheckIsAdmin, ApiCheckUsername, ApiDeleteUser, ApiGetCompanyList, ApiGetUserById, ApiRegister, ApiRegisterUser, ApiUpdateUser } from "utils/constants/api";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'

export default function CustomerLoginForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()

    const { fetch: apiRegisterUser } = useFetch(ApiRegisterUser)
    const { fetch: apiUpdateUser } = useFetch(ApiUpdateUser)
    const { fetch: apiGetUserById } = useFetch(ApiGetUserById)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiGetCompanyList } = useFetch(ApiGetCompanyList)
    const { fetch: apiCheckUsername } = useFetch(ApiCheckUsername)


    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")
    let userId = queryString.get("customerLoginId")
    
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    const [companyOptions, setCompanyOptions] = useState([])
    const [company, setCompany] = useState(null)
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false)

    // Error State

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorUsernameMessage, setErrorUsernameMessage] = useState('Username is required!')
    const [errorName, setErrorName] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)
    
    // Button Event
    const saveBtnClick = () => {
        if(fFormValidation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        insertUser().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        navigate("/customer-login") 
                                    }
                                })
                            }
                        })
                    } else {
                        updateUser().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        navigate("/customer-login") 
                                    }
                                })
                            }
                        })
                    }
                }
            })
        }
    }
    const deleteBtnClick = () => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteUser(status === 1 ? '2' : '1').then((res) => {
                    if (checkResponse(res)) {
                        openModal(ModalTypeSuccess, {
                            onSuccess: () => {
                                closeModal()
                                navigate("/customer-login") 
                            }
                        })
                    }
                })
            }
        })
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // API Calls
    const insertUser = async() => {
        let res = await apiRegisterUser({
            data: {
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin,
                companyId: company?.value || null
            }
        })

        return res
    }
    const updateUser = async() => {
        let res = await apiUpdateUser({
            data: {
                userId,
                username: username,
                fullName: name,
                password: password,
                isAdmin: isAdmin,
                companyId: company?.value || null
            }
        })

        return res
    }
    const deleteUser = async(status) => {
        let res = await apiDeleteUser({
            data: {
                userId,
                status
            }
        })

        return res
    }
    const getUserById = async() => {
        let res = await apiGetUserById({
            data: {
                userId
            }
        })

        return res
    }
    const getCompanyList = async() => {
        let res = await apiGetCompanyList({
            data: {
                companyName: '', 
                status: '1',
                pageSize: 100,
                pageIndex: 0
            }
        })

        return res
    }
    const checkUsername = async() => {
        let res = await apiCheckUsername({
            data: {
                username
            }
        })

        return res
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (username === EmptyString || username === null){
            setErrorUsername(true)
            errorCount++
        }else{
            setErrorUsername(false)
        }

        if (name === EmptyString || name === null){
            setErrorName(true)
            errorCount++
        }else{
            setErrorName(false)
        }

        if (password === EmptyString || password === null){
            setErrorPassword(true)
            errorCount++
        }else{
            setErrorPassword(false)
        }

        if (confirmPassword === EmptyString || confirmPassword === null){
            setErrorConfirmPasswordMessage("Confirm Password is required")
            setErrorConfirmPassword(true)
            errorCount++
        }else{
            setErrorConfirmPassword(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }

    const checkResponse = (res) => {
        if (res.status === ApiResponseSuccess) {
            return true
        } else if (res.status === ApiResponseStatusUnauthorized) {
            window.location.href = "/login"
            return false
        } else {
            openModal(ModalTypeFail, { message: res.message })
            return false
        }
    }
    
    useEffect(() => {
        getCompanyList().then((res) => {
            if (checkResponse(res)) {
                let data = res?.data?.listData
                let tempData = [{ label: 'Select Client', value: '' }]

                data.map((data, i) => tempData.push({ label: data.companyName.toUpperCase(), value: String(data.companyId) }))

                setCompanyOptions(tempData)

                if (formType === FormTypeEdit){
                    openModal(ModalTypeLoading)

                    getUserById().then((res) => {
                        if (checkResponse(res)) {
                            let data = res.data

                            setUsername(data.username)
                            setName(data.fullName)
                            setIsAdmin(data.isAdmin)
                            setCompany(tempData.find(option => option.value === String(data.companyId)))

                            // Header 
                            setStatus(data.status)
                            setCreateDate(data.createdDate)
                            setUpdateDate(data.updatedDate)
                            setUpdateBy(data.updatedBy)

                            closeModal()
                        }
                    })
                }
            }
        })
        
    }, [])

    useEffect(() => {
        checkUsername().then((res) => {
            if (checkResponse(res)) {
                let data = res.data

                if (data.duplicate) {
                    setErrorUsername(true)
                    setErrorUsernameMessage("Username already exists!")
                    setIsSaveButtonDisabled(true)
                } else {
                    setErrorUsername(false)
                    setErrorUsernameMessage("Username is required!")
                    setIsSaveButtonDisabled(false)

                }
            }
        })
    }, [username])

    return(
        <div className="flex flex-col gap-2 p-6">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Customer Login Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Username */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Username</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorUsername ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{errorUsernameMessage}</span>
                    </div>
                </div>

                {/* Name */}
                <FormCard title="Name">
                    <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} maxLength={30} />
                </FormCard>

                {/* Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={password} onChange={(e) => { setPassword(e.target.value) }} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Password is required!</span>
                    </div>
                </div>

                {/* Confirm Password */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Confirm Password</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input type="password" className="input" value={confirmPassword} onChange={(e) => {setConfirmPassword(e.target.value)}} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorConfirmPassword ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">{ errorConfirmPasswordMessage }</span>
                    </div>
                </div>

                {/* Admin */}
                <FormCard title="Admin">
                    <input type="checkbox" className="" value={isAdmin} onChange={(e) => {setIsAdmin(!isAdmin)}} checked={isAdmin} />
                </FormCard>

                {/* Client */}
                <FormCard title="Client">
                    <Select className="w-full" options={companyOptions} value={company} onChange={(e) => {setCompany(e)}} placeholder='Select Client' />
                </FormCard>

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} disabled={isSaveButtonDisabled} />
                    <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '1' ? true : false) : false} />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === '2' ? true : false) : false} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
    )
}

const FormCard = ({ title, children }) => {
    return(
        <div className="flex items-center">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72 flex items-center">
                {children}
            </div>
        </div>
    )
}